import {
  createStore as createReduxStore,
  applyMiddleware,
  compose,
  Middleware,
  StoreEnhancer
} from 'redux'

import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import createSagaMiddleware from 'redux-saga'
import rootReducer from './reducers'
import sessionSaga from './modules/session/sagas'

const persistConfig = {
  key: 'foosio',
  storage,
  throttle: 300,
  whitelist: ['settings']
}

const createStore = () => {
  const sagaMiddleware = createSagaMiddleware()
  const persistedReducer = persistReducer(persistConfig, rootReducer)

  const middleware: Middleware[] = [
    sagaMiddleware,
  ]
  const enhancers: StoreEnhancer[] = []

  /* tslint:disable-next-line:no-any */
  const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

  const store = createReduxStore(
    persistedReducer,
    composeEnhancers(
      applyMiddleware(...middleware),
      ...enhancers
    )
  )

  sagaMiddleware.run(sessionSaga)

  const persistor = persistStore(store)

  return { store, persistor }
}

export default createStore
